const currentYear = new Date().getFullYear();

export const payDateDictionary = [
  { month: "January", payDate: `01/27/${currentYear}`, time: "00:00:00" },
  { month: "February", payDate: `02/27/${currentYear}`, time: "00:00:00" },
  { month: "March", payDate: `03/27/${currentYear}`, time: "00:00:00" },
  { month: "April", payDate: `04/24/${currentYear}`, time: "00:00:00" },
  { month: "May", payDate: `05/27/${currentYear}`, time: "00:00:00" },
  { month: "June", payDate: `06/26/${currentYear}`, time: "00:00:00" },
  { month: "July", payDate: `07/25/${currentYear}`, time: "00:00:00" },
  { month: "August", payDate: `08/27/${currentYear}`, time: "00:00:00" },
  { month: "September", payDate: `09/27/${currentYear}`, time: "00:00:00" },
  { month: "October", payDate: `10/27/${currentYear}`, time: "00:00:00" },
  { month: "November", payDate: `11/27/${currentYear}`, time: "00:00:00" },
  { month: "Christmas", payDate: `12/23/${currentYear}`, time: "00:00:00" },
];
